import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { KizenTypography } from '__app/typography';
import { truncateCss } from 'app/typography';

import { GenericWizardSection } from '__components/GenericWizard';
import { SelectNoScrollCapture as Select } from '__components/Inputs/Select';
import InputControl from '__components/Inputs/InputControl';
import Cols from '__components/Layout/Cols';
import { breakpoints } from '@kizen/page-builder/internal/app/spacing';

import Loader from '__components/Kizen/Loader';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

export const ActionOnFailureSelect = styled(Select)<{ marginBottom?: number }>`
  width: 273px; // taken from figma
`;

export const ActionOnFailureNote = styled(KizenTypography)`
  font-style: italic;
  margin-top: 15px;
  color: var(--color-font-placeholder);
`;

export const StyledHeading = styled(KizenTypography)`
  line-height: 1em;
`;

export const VariableTypeHeading = styled(StyledHeading)`
  && {
    margin-bottom: 14px;
    margin-top: 18px;
  }
`;

export const VariableBlockHeading = styled(StyledHeading)`
  && {
    margin-bottom: 15px;
  }
`;

export const ActionOnFailureSection = styled(GenericWizardSection)<{
  header: string;
  headerType: string;
  isActive: boolean;
}>`
  > div {
    display: flex;
    column-gap: 20px;
    min-width: 1px;

    > div:first-child {
      max-width: 255px;
    }
  }
`;

export const SwitchControlWrapper = styled(InputControl)`
  > label {
    margin-bottom: 20px;
    & + * {
      margin: 0;
      label {
        // Incidentally part of <Switch />
        margin: 0;
      }
    }
  }
`;

// grouped button grid
export const Section = styled.div`
  &:not(:last-child) {
    margin-bottom: 18px;
  }
  h3 {
    line-height: 1;
    margin-bottom: 11px;
  }
`;

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
  button {
    padding-top: 19px;
    span {
      ${truncateCss}
      margin-top: 10px;
    }
  }
`;

export const StackableCols = styled(Cols)`
  > div {
    margin-bottom: 15px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    > div {
      margin-bottom: 0;
    }
  }
`;

export const VariableNameCols = styled(StackableCols)`
  margin-bottom: 20px;
`;

export const StyledLastExecutableRuleWarning = styled(TextEllipsisWithTooltip)`
  margin-top: -10px;
  && {
    margin-bottom: 10px;
  }
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px;
  background: var(--color-feedback-info-bg);
`;

export const StyledLoader = styled(Loader)`
  ${({ loading }) =>
    loading &&
    css`
      padding-top: 5% !important;
    `}
`;

export const ButtonGroupWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;
